import { FormControl } from '@angular/forms';
import * as IBAN from 'iban';

export function ValidateIban(prefix?: string) {
  return (control: FormControl) => {
    let value = control.value;
    // dont valid empty iban
    if (!value || value.length < 1) {
      return null;
    }
    if (prefix) {
      value = prefix + value;
    }
    let isValid = IBAN.isValid(value);

    return isValid ? null : { validIban: true };
  }
}
